module.exports = __webpack_public_path__ + "img/examples-img02.57a78127.jpg";